import React from "react";
import ContentEditable from "react-contenteditable";
import { useDispatch } from "react-redux";
import { Rnd } from "react-rnd";
import {
  batchUpdateLayer,
  selectLayer,
} from "../../features/counter/counterSlice";

function ImageComponent({ layer }) {
  const [text, setText] = React.useState("");

  React.useEffect(() => {
    setText(layer.text);
  }, [layer.text]);

  const handleChange = (e) => {
    setText(e.target.value);
  };
  const handleDragStop = (e, { x, y }) => {
    dispatch(
      batchUpdateLayer({
        x,
        y,
      })
    );
  };
  const dispatch = useDispatch();

  const setSelected = () => {
    dispatch(selectLayer(layer));
  };
  return (
    <Rnd
      onMouseDown={setSelected}
      default={{ x: layer.x, y: layer.y }}
      className="draggable-layer"
      onDragStop={handleDragStop}
    >
      <img
        onMouseDown={setSelected}
        src={layer.url}
        className="draggable-image"
        draggable={false}
      />
    </Rnd>
  );
}

export default ImageComponent;
